import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';

export function useIsLoggedIn() {
  const { user } = useUserEnvironment();
  return Boolean(user);
}
